import React, { useState, useEffect } from 'react';
// import * as nearAPI from 'near-api-js';
import { Box, Button, Image } from '@chakra-ui/react';
import logo from '../assets/Smart Builders Logo.png';
import brandName from '../assets/Smart Builders Logo text.png';
// import nearIcon from '../assets/near-icon.png';
import connectors from '../utils/connectors'


const Header = () => {
  const connector = connectors["UAuth"][0];

  const [text, setText] = useState('Login with Unstoppable')

  const { useIsActivating, useIsActive } = connectors['UAuth'][1];
  const isActivating = useIsActivating();
  const isActive = useIsActive();

  // const [connectionStatus, setConnectionStatus] = useState('Disconnected');
  // const [error, setError] = useState();

  const getDomainName = JSON.parse(localStorage.getItem('currentUser'));

  useEffect(() => {
    if (getDomainName === '' || getDomainName === null) {
      setText('Login with Unstoppable');
    } else {
      setText(getDomainName.sub);
    }
  }, [getDomainName]);

  // Handle connector activation and update connection/error state
  const handleToggleConnect = async () => {
    // setError(undefined); // Clear error state

    if (isActive) {
      if (connector?.deactivate) {
        void connector.deactivate();
      } else {
        void connector.resetState();
      }
      // setConnectionStatus('Disconnected');
    } else if (!isActivating) {
      // setConnectionStatus('Connecting...');
      setText('Connecting...');

      // Activate the connector and update states
      connector
        .activate(1)
        .then(() => {
          // setConnectionStatus('Connected');
        })
        .catch((e) => {
          connector.resetState();
          // setError(e);
        });

        const authorization = await connector.uauth.user();
        localStorage.setItem('currentUser', JSON.stringify(authorization));
        setText(getDomainName.sub);
     // console.log(authorization);
    } else if (text !== 'Login with Unstoppable') {
      await connector.uauth.logout();
      localStorage.setItem('currentUser', JSON.stringify(''));
      setText('Login with Unstoppable');
      
    }
  };

  return (
    <Box
      as="header"
      w="100%"
      position="fixed"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      h="20%"
      p="1.5rem"
      bg="white"
      top="0"
      zIndex={2}
    >
      <Box display="flex" alignItems="center">
        <Image boxSize="40px" src={logo} alt="logo" />
        <Image ml="1rem" src={brandName} alt="brandName" />
      </Box>

      <Box display="flex" alignItems="center">
        {/* <Image boxSize="40px" src={nearIcon} alt="nearIcon" /> */}
        <Button
          ml="1.5rem"
          p="1.5rem"
          bg="brand.primary"
          color="white"
          borderRadius="15px"
          _hover={{
            bg: 'brand.primary',
            opacity: '0.8',
            color: 'black',
          }}
        >
          Connect Wallet
        </Button>

        <Button
          ml="1.5rem"
          p="1.5rem"
          bg="brand.primary"
          color="white"
          borderRadius="15px"
          _hover={{
            bg: 'brand.primary',
            opacity: '0.8',
            color: 'black',
          }}
          onClick={handleToggleConnect}
        >
          {/* {isActive ? text : 'Logout' } */}
          {text}
        </Button>
      </Box>
    </Box>
  );
};

export default Header;

// passphrase: wreck paper grunt roast lonely join rail tourist double soldier name wise
// devcreed.testnet;
